export default __webpack_public_path__ + "968e33dd4da060fd8ccb5b9d37b2ca74.jpg";